import { ActionIcon, Group, TextInput, useMantineTheme } from '@mantine/core';
import { RiExpandDiagonalLine } from 'react-icons/ri';
import { LuEraser } from 'react-icons/lu';
import { t } from 'i18next';

export type GraphOutputInputProps = {
  value: unknown;
  placeholder?: string;
  onOpen: () => void;
  onClear: () => void;
};

export const GraphOutputInput = ({
  value,
  placeholder = t('graphEditor.graphOutputInput.emptyPlaceholder'),
  onOpen,
  onClear,
}: GraphOutputInputProps) => {
  const theme = useMantineTheme();

  return (
    <Group spacing="sm" align="center" noWrap>
      <TextInput
        readOnly
        value={JSON.stringify(value)}
        placeholder={placeholder}
        sx={{ flex: 2 }}
        styles={{
          input: {
            fontFamily: theme.fontFamilyMonospace,
            fontSize: theme.fontSizes.xs,
          },
        }}
      />
      <ActionIcon
        variant="default"
        size="lg"
        onClick={onOpen}
        aria-label={t('graphEditor.graphOutputInput.openGraph')}
      >
        <RiExpandDiagonalLine />
      </ActionIcon>
      <ActionIcon
        color="gray"
        variant="default"
        size="lg"
        onClick={onClear}
        aria-label={t('graphEditor.graphOutputInput.clearGraph')}
      >
        <LuEraser />
      </ActionIcon>
    </Group>
  );
};
